import { queryApi } from 'app/apis/queryApi';
import { GetAdvancedReportResponse } from './advanced-report-api.types';
import {
  AdvancedReportMetricRow,
  AdvancedReportQueryRequestDto
} from 'features/advanced-reports/advanced-reports.types';
import { createMetrics } from './factories/advanced-report-metric-row-factory';

function handleTransformResponse(
  response: GetAdvancedReportResponse,
  _: unknown,
  request: AdvancedReportQueryRequestDto
): AdvancedReportMetricRow[] {
  const metrics = response.metrics.flatMap((metric) =>
    createMetrics(metric, request)
  );

  return metrics;
}

export const advancedReportQueryApi = queryApi.injectEndpoints({
  endpoints: (builder) => ({
    getClicksAdvancedReport: builder.mutation<
      AdvancedReportMetricRow[],
      AdvancedReportQueryRequestDto
    >({
      query: (request) => ({
        url: `${request.siteId}/web-touchpoint/clicks/advanced-report`,
        method: 'POST',
        body: request
      }),
      transformResponse: handleTransformResponse
    }),
    getConversionAdvancedReport: builder.mutation<
      AdvancedReportMetricRow[],
      AdvancedReportQueryRequestDto
    >({
      query: (request) => ({
        url: `${request.siteId}/conversion/advanced-report`,
        method: 'POST',
        body: request
      }),
      transformResponse: handleTransformResponse
    }),
    getOpportunityAdvancedReport: builder.mutation<
      AdvancedReportMetricRow[],
      AdvancedReportQueryRequestDto
    >({
      query: (request) => ({
        url: `${request.siteId}/opportunities/advanced-report`,
        method: 'POST',
        body: request
      }),
      transformResponse: handleTransformResponse
    }),
    getRevenueAdvancedReport: builder.mutation<
      AdvancedReportMetricRow[],
      AdvancedReportQueryRequestDto
    >({
      query: (request) => ({
        url: `${request.siteId}/revenue/advanced-report`,
        method: 'POST',
        body: request
      }),
      transformResponse: handleTransformResponse
    }),
    getCostAdvancedReport: builder.mutation<
      AdvancedReportMetricRow[],
      AdvancedReportQueryRequestDto
    >({
      query: (request) => ({
        url: `${request.siteId}/adcost/advanced-report`,
        method: 'POST',
        body: request
      }),
      transformResponse: handleTransformResponse
    }),
    getClicksReport: builder.query<
      AdvancedReportMetricRow[],
      AdvancedReportQueryRequestDto
    >({
      query: (request) => ({
        url: `${request.siteId}/web-touchpoint/clicks/advanced-report`,
        method: 'POST',
        body: request
      }),
      transformResponse: handleTransformResponse
    }),
    getCostReport: builder.query<
      AdvancedReportMetricRow[],
      AdvancedReportQueryRequestDto
    >({
      query: (request) => ({
        url: `${request.siteId}/adcost/advanced-report`,
        method: 'POST',
        body: request
      }),
      transformResponse: handleTransformResponse
    }),
    getConversionReport: builder.query<
      AdvancedReportMetricRow[],
      AdvancedReportQueryRequestDto
    >({
      query: (request) => ({
        url: `${request.siteId}/conversion/advanced-report`,
        method: 'POST',
        body: request
      }),
      transformResponse: handleTransformResponse
    }),
    getRevenueReport: builder.query<
      AdvancedReportMetricRow[],
      AdvancedReportQueryRequestDto
    >({
      query: (request) => ({
        url: `${request.siteId}/revenue/advanced-report`,
        method: 'POST',
        body: request
      }),
      transformResponse: handleTransformResponse
    }),
    getOpportunityReport: builder.query<
      AdvancedReportMetricRow[],
      AdvancedReportQueryRequestDto
    >({
      query: (request) => ({
        url: `${request.siteId}/opportunities/advanced-report`,
        method: 'POST',
        body: request
      }),
      transformResponse: handleTransformResponse
    })
  }),
  overrideExisting: false
});

export const {
  useGetClicksAdvancedReportMutation,
  useGetConversionAdvancedReportMutation,
  useGetOpportunityAdvancedReportMutation,
  useGetRevenueAdvancedReportMutation,
  useGetCostAdvancedReportMutation,
  useGetClicksReportQuery,
  useGetCostReportQuery,
  useGetConversionReportQuery,
  useGetRevenueReportQuery,
  useGetOpportunityReportQuery
} = advancedReportQueryApi;
